import {
  BulkListingPriceCalculation,
  ListingPriceCalculation,
} from 'src/WebApiController';

// Show the pricing-against tooltip only when a pricing calc exists for this row (none in the no-selection panel).
export const hasListingPricingContext = (
  listingId: number,
  listingPriceCalc?: ListingPriceCalculation | null,
  listingPriceCalculations?: BulkListingPriceCalculation[] | null
): boolean => {
  return (
    Boolean(listingPriceCalc) ||
    Boolean(
      listingPriceCalculations?.some((calc) => calc.listingId === listingId)
    )
  );
};
